module.exports = __webpack_public_path__ + "img/testimonials-buttons-ellipse.b8df9c90.svg";